import { PIEVE_MODEL_MAP } from './modelCatalog.js';

/**
 * Returns a model's context window in tokens from the catalog, or null when the
 * model is unknown. Drives attachment budgeting, the context-usage display, and
 * the fallback compaction threshold.
 */
const resolveModelContextWindowTokens = (modelId) => {
  return PIEVE_MODEL_MAP[modelId]?.contextWindowTokens ?? null;
};

export default resolveModelContextWindowTokens;
